module.exports = __webpack_public_path__ + "static/media/weight.3c1f587f.svg";